import {
  AppointmentInsuranceType,
  PatientTransactionItemType,
} from '@chiroup/core';
import { MeContext } from '../../../../../../contexts/me.context';
import { billingService } from '../../../../../../services/billing.service';
import { useContext, useEffect, useState } from 'react';
import { QueryFunctionContext, useQuery } from 'react-query';

const getQuery = function (clinicId: number) {
  return async (context: QueryFunctionContext) => {
    const parentId = context.queryKey[1] as string;
    if (parentId === 'new') {
      return {} as any;
    }
    return billingService.encounterServices.get({
      id: parentId as string,
      clinicId,
    });
  };
};

const useServices = ({ billingKey }: { billingKey?: string }) => {
  const { me } = useContext(MeContext);
  const [snapshot, setSnapshot] = useState<string>();
  const [listofServices, setListofServices] = useState<
    PatientTransactionItemType[]
  >([]);
  const [insurances, setInsurances] = useState<
    Partial<AppointmentInsuranceType>[]
  >([]);
  const [allowBillingPriorityChange, setAllowBillingPriorityChange] =
    useState(false);
  const [payors, setPayors] = useState<any[]>([]);
  const [locked, setLocked] = useState(false);
  const [courtesyBilling, setCourtesyBilling] = useState(false);
  const { status, data, error, isFetching, refetch } = useQuery<any>(
    ['transactionServices', billingKey],
    getQuery(me?.selectedClinic?.ID || -1),
    {
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    // TODO: We should probably be updating the cache inside of useQuery instead of setting a bunch of more state.
    // It would also be nice to not have to pass down all of the setters...
    if (data) {
      setAllowBillingPriorityChange(data.allowBillingPriorityChange);
      setInsurances(data.insurances || []);
      setListofServices(data.services || []);
      setPayors(data.payors);
      setSnapshot(JSON.stringify(data));
      setCourtesyBilling(data.courtesyBilling);
      setLocked(data.services?.[0]?.locked || false);
    }
  }, [data]);

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
    listofServices,
    insurances,
    payors,
    snapshot,
    locked,
    setListofServices,
    setSnapshot,
    setInsurances,
    setLocked,
    setPayors,
    setCourtesyBilling,
    allowBillingPriorityChange,
    courtesyBilling,
  };
};

export default useServices;
